"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureType = void 0;
var SignatureType;
(function (SignatureType) {
    SignatureType["DRAWN"] = "DRAWN";
    SignatureType["TYPED_NAME"] = "TYPED_NAME";
    SignatureType["TYPED_EMAIL"] = "TYPED_EMAIL";
    SignatureType["TYPED_ANYTHING"] = "TYPED_ANYTHING";
    SignatureType["TYPED"] = "TYPED";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
//# sourceMappingURL=signatureType.js.map